import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges, TemplateRef, ViewChild } from '@angular/core';
import { BnLoadingService, EntityOrderedRequestParameters, EntityPagedRequestParameters, MessageChannelService, messageLevel } from "@bndes/bndes-ux4/bndes-angular-utils";
import { BnModalMessageService } from "@bndes/bndes-ux4/bn-modal-message";

import { MensagemRetornoAssincrono } from '../../..//model/mensagem-retorno-assincrono.model';
import { FileUtilsService } from '../../../shared/file-utils.service';
import { PermissaoService } from '../../../shared/permissao.service';
import { ProtocoloArquivoIpdService } from '../../services/protocolo-arquivo-ipd.service';
import { STATUS_CONSULTA_PROTOCOLO } from '../../../model/protocolo-arquivo-ipd.model';
import { ROLE_GESTOR_CONSULTA } from 'src/app/constantes/permissao.constants';
import {ProtocoloArquivo, ProtocoloConsultaImpedimento} from "../../../model/protocolo-arquivo.model";

@Component({
  selector: 'app-protocolo-listar-ipd',
  templateUrl: './protocolo-listar-ipd.component.html',
  styleUrl: './protocolo-listar-ipd.component.scss',
  standalone:false
})
export class ProtocoloListarIpdComponent implements OnInit, OnChanges {

    @ViewChild('confirmacaoMensagem') desativacaoMsg?: TemplateRef<any>;
    @ViewChild('desativacaoBotoes') desativacaoBotoes?: TemplateRef<any>;

    @ViewChild('confirmacaoSwitchMensagem') confirmacaoSwitchMensagem!: TemplateRef<any>;
    @ViewChild('confirmacaoSwitchBotoes') confirmacaoSwitchBotoes!: TemplateRef<any>;

    @Input() public cnpjAgente?: string;
    @Input() public protocolos: ProtocoloConsultaImpedimento[];
    @Input() public exibirComboTipoArquivo:boolean = false;
    @Input() public atributosPaginacao: EntityPagedRequestParameters;
    @Input() public formatoArquivo: string;
    @Output() public aoMudarPagina: EventEmitter<EntityPagedRequestParameters> = new EventEmitter<EntityPagedRequestParameters>();
    @Output() public aoProcessarArquivo: EventEmitter<void> = new EventEmitter<void>();

    public opcoesPaginacao: number[] = [10,15,20];
    public atributosOrdenacao: EntityOrderedRequestParameters;

    public protocolosPaginados: ProtocoloConsultaImpedimento[];
    private protocolosTemp: ProtocoloConsultaImpedimento[];
    private podeProcessarArquivo :boolean = false;

    listagemExibida: ProtocoloConsultaImpedimento[] = [];


    constructor(
        private fileUtils: FileUtilsService,
        private protocoloService: ProtocoloArquivoIpdService,
        private permissaoService: PermissaoService,
        private loadingService: BnLoadingService,
        private messageService: MessageChannelService,
        private modalService: BnModalMessageService) { }


    ngOnInit(): void {

      this.atributosOrdenacao = { atributo:'', sentido:'asc'}

        this.permissaoService.getPermissoesUsuarioAutenticado().subscribe((resp: any) => {
                  this.podeProcessarArquivo = resp && resp[ROLE_GESTOR_CONSULTA];
        });
    }

    ngOnChanges(changes: SimpleChanges): void {
        this.pesquisar(this.atributosPaginacao);
    }

    mudancaPagina(novaPagina: EntityPagedRequestParameters) {
        this.atributosPaginacao = novaPagina;
        this.aoMudarPagina.emit(novaPagina);
      }

    mudancaOrdenacao(novaOrdenacao: EntityOrderedRequestParameters) {
        this.atributosOrdenacao = novaOrdenacao;
        this.pesquisarOrdenacao(this.atributosOrdenacao);
        this.pesquisar(this.atributosPaginacao);
    }

    pesquisarOrdenacao(ord: EntityOrderedRequestParameters) {
        this.protocolos.sort((a, b) => {
            if (ord.sentido === 'asc') {
                return this.compara(a, b, ord.atributo);
            } else {
                return -1 * this.compara(a, b, ord.atributo);
            }
        });
    }


    private compara(a, b, atributo): number {
        if (this.fetchFromObject(a, atributo) === this.fetchFromObject(b, atributo)) {
            return 0;
        } else {
            if (this.fetchFromObject(a, atributo) > this.fetchFromObject(b, atributo)) {
                return 1;
            } else {
                return -1;
            }
        }
    }

    private fetchFromObject(obj, prop) {
        if (typeof obj === 'undefined') {
            return false;
        }

        const _index = prop.indexOf('.');
        if (_index > -1) {
            return this.fetchFromObject(obj[prop.substring(0, _index)], prop.substr(_index + 1));
        }

        return obj[prop];
    }

    private pesquisar(pesq: EntityPagedRequestParameters) {
        this.protocolosTemp = this.protocolos;
        if (this.protocolosTemp) {
            this.protocolosPaginados = this.protocolosTemp.slice(0, pesq.pageSize);
        }
     }

    downloadArquivoEnvio(idProtocoloArquivo: string) {


        this.protocoloService.getArquivoEnvio(idProtocoloArquivo).subscribe((conteudoArquivo) => {
            this.fileUtils.exportarArquivo('Arquivo_envio_' + idProtocoloArquivo + '.json',
                JSON.stringify(conteudoArquivo), FileUtilsService.APPLICATION_JSON);
        });

    }

    downloadArquivoResposta(idProtocoloArquivo: string) {

        this.protocoloService.getArquivoResposta(idProtocoloArquivo).subscribe((conteudoArquivo) => {
            this.fileUtils.exportarArquivo('Arquivo_resposta_' + idProtocoloArquivo + '.json',
              JSON.stringify(conteudoArquivo), FileUtilsService.APPLICATION_JSON);
          });

    }

    obterLabelStatusProtocolo(statusProtocolo: string) {
        return STATUS_CONSULTA_PROTOCOLO.find(status => status.codigo === statusProtocolo).label;
    }


  confirmarMudancaReenvio(event: any, protocolo: ProtocoloConsultaImpedimento) {

    event.preventDefault();

    const titulo = 'Confirmação';
    const mensagem = `Deseja processar ${protocolo.identificadorProtocoloNegocio}.`

    return this.modalService.abrirConfirm(titulo, mensagem).result
      .then((retorno) => {
        if (retorno === 'ok' || retorno.value === 'ok') {

          this.loadingService.bloqueiaTela();

          this.protocoloService.processarProtocolo(protocolo.identificadorProtocoloNegocio).subscribe(
            (retorno: any) => {
              this.loadingService.liberaTela();
              const msgRetornoProtocolo = (<MensagemRetornoAssincrono>retorno);

              this.messageService.addMessage({
                title: 'Sucesso',
                type: 'CRUD_OPERATION',
                level: messageLevel.SUCCESS,
                message: `${protocolo.identificadorProtocoloNegocio}. ${msgRetornoProtocolo.mensagem}`
              });

              this.aoProcessarArquivo.emit();

            },
            (erro) => {
              this.loadingService.liberaTela();
              console.log("ERRO ", erro)
            }
          );
        }
      })
      .catch((erro) => {
        console.log("ERRO ", erro)
      });

  }

    getPodeProcessar(protocolo: any){

        return true;

        //return protocolo.statusProtocolo =="P" && this.podeProcessarArquivo;
    }

    getVisualizarProcessarArquivo(){

        return true;
       // return this.podeProcessarArquivo;
    }

}
